import {AConfig} from './AConfig';
import {ObjectConfig} from './ObjectConfig';
import {appInjector} from '../classes/appInjector';
import {ToolsService} from '../services/toolsService/tools.service';
import {Subject} from 'rxjs';
import {isRemoveSidebar} from '../../configs/view_only';
import {ToolType} from "../../configs/toolsEnum";
import { INPUT_COLOR_SETTINGS_NAME, INPUT_OPACITY_SETTINGS_NAME } from "../interfaces/constants";

export class ItemConfig extends AConfig{
  private id = null;
  private toolId = null;
  private title = null;
  private originalTitle = null;
  private inputs = {};
  private group = null;
  private copyOf = null;
  private _copies = null;

  get copies(){
    return this._copies;
  }

  set copies(val){
    this._copies = val;
  }

  get isContainPreset(){
    return this.getTool().is_preset;
  }

  get isCopy(){
    return this.copyOf || this.copyOf == 0;
  }

  removeCopyOf(){
    this.copyOf = null;
    this.onChange();
  }

  set copyParent(val){
    this.copyOf = val;
    this.onChange();
  }

  get getCopyParentId(){
    return this.copyOf;
  }
  private _copyDirection = null;
  get copyDirection(){
    return this._copyDirection || 'x';
  }
  set copyDirection(value:string){
    this._copyDirection = value;
    // this.onChange();
  }
  private _copyGapInMeters = null;
  get copyGapInMeters(){
    return this._copyGapInMeters || 0;
  }
  set copyGapInMeters(val: number){
    this._copyGapInMeters = val;
    this.onChange();
  }
  private objects: ObjectConfig[] = [new ObjectConfig()];
  private hasTag = null;
  private showTag = true;
  private bundledItems = null;
  private teamId = null;
  private team = null;
  private creator = null;
  private creatorEmail = null;
  private createdAt = null;
  private measurement = null;
  private pluginConfigs = {};
  private concreteLayerId = null;
  private groupId = null;

  private oldConfig = null;

  public _convertedInputs = {};
  private _oldConfigHash = null;
  public _subject : Subject<ItemConfig> = new Subject<ItemConfig>();
  get subject(){
    return this._subject.asObservable();
  }
  public _serverUpdate : Subject<ItemConfig> = new Subject<ItemConfig>();
  get serverUpdate(){
    return this._serverUpdate.asObservable();
  }

  /**
   * Map<inputName, objectPropertyName>
   * Specified inputs will be copied to the ObjectConfig
   */
  public mapInputsToObjectConfig: Map<string, string> = new Map([
    ['fixedWidth', 'fixed_width'],
    ['fixedWidthPx', 'fixed_width_px'],
    ['fixedHeight', 'fixed_height'],
    ['__figure_zoom', 'fixed_scale'],
    ['lineColor', 'strokeColor'],
    ['fillColor', 'fillColor'],
    [INPUT_COLOR_SETTINGS_NAME, 'strokeColor'],
    [INPUT_OPACITY_SETTINGS_NAME, 'importantOpacity']
  ]);

  constructor(config?) {
    super();
    if (window.hasOwnProperty('CAN_CHANGE_OBJECT_ICON') && window['CAN_CHANGE_OBJECT_ICON']) {
      this.mapInputsToObjectConfig.set('customIcon', 'map_icon');
    }
    if (config) {
      this.assign(config);
    }
    if (!isRemoveSidebar) {
      this.getObjectConfig().subject.subscribe(this.onChange.bind(this));
    }
  }

  public getGroupId() {
    if(this.groupId === null){
      if (this.group){
        return this.group;
      }
      return -1;
    }
    else{
      return this.groupId;
    }
  }
  public setGroupId(value){
    let res = value;
    if (value == -1){
      res = null;
    }
    this.groupId = res;
    this.onChange();
  }

  public isValid() {
    const objConfig = this.getObjectConfig();
    if (!objConfig) {
      return false;
    }
    return objConfig.isValid();
  }

  public setData(key:string, value:any) {
    this[key] = value;
    this.onChange();
  }

  public getObjectConfig(): ObjectConfig {
    return ((this.objects.length > 0) ? this.objects[0] : null);
  }

  public setObjectConfig(config, withoutOldConfig?) {
    if (!this.getObjectConfig()) {
      this.objects = [new ObjectConfig()];
    }
    this.mapInputsToObjectConfig.forEach((objectProp, inputName) => {
      const inputValue = this.getInputProp(inputName, 'value');
      if (inputValue !== null) {
        if (config instanceof ObjectConfig) {
          config.setData(objectProp, inputValue);
        } else {
          config[objectProp] = inputValue;
        }
      }
    });

    const inputs = this.getInputs();
    //set some properties from inputs
    let isDashWidthInMeters = null;
    for (const name in inputs) {
      if (inputs[name].hasOwnProperty('isWidthInMeters') && inputs[name].isWidthInMeters){
        if (config instanceof ObjectConfig) {
          config.setData('dashWidthInMeters', inputs[name].value);
        }
        else{
          config.dashWidthInMeters = inputs[name].value;
        }
        isDashWidthInMeters = inputs[name].value;
      }
    }

    if (isDashWidthInMeters == null){
      if (config instanceof ObjectConfig) {
        config.setData('dashWidthInMeters', null);
      }
      else{
        config.dashWidthInMeters = null;
      }
    }

    this.getObjectConfig().assign(config, withoutOldConfig);
  }

  public getOldConfig(){return this.oldConfig}
  public getOldConfigHash(){return this._oldConfigHash}
  public getRotation():number {return this.getObjectConfig().getRotation()}
  public setId(id) { this.setData('id', id); }
  public getId() { return this.id; }
  public getToolId() {return this.toolId;}
  public getGroup() {return this.group;}
  public getTitle() {return this.title;}
  public isFixedFigure() {return this.getObjectConfig().getToolType() == 'fixed-figure';}
  public isPolygon() {return this.getObjectConfig().getToolType() == ToolType.Polygon;}
  public isCircle() {return this.getObjectConfig().getToolType() == ToolType.Circle;}
  public getCreator() {return this.creatorEmail;}
  public getCreatorAt() {return this.createdAt;}
  public getConcreteLayerId() {return this.concreteLayerId;}
  public setConcreteLayerId(id) {
    this.concreteLayerId = id;
    this.onChange();
  }

  public setTitle(title) {
    this.setData('title', title);
  }

  public createInputValue(key, object) {
    this.inputs[key] = object;
    if (this.mapInputsToObjectConfig.has(key)) {
      this.getObjectConfig().setData(this.mapInputsToObjectConfig.get(key), object.value);
    } else {
      this.onChange();
    }
  }

  public setInputValue(key, prop, val, isSilent?): void {
    if (!this.inputs[key]) {
      this.inputs[key] = {};
    }
    this.inputs[key][prop] = val;

    if (this.inputs[key].hasOwnProperty('isWidthInMeters')) {
      this.getObjectConfig().setDashWidthInMeters(this.inputs[key].value);
    }

    if (this.mapInputsToObjectConfig.has(key)) {
      this.getObjectConfig().setData(this.mapInputsToObjectConfig.get(key), val, isSilent);
    } else {
      this.onChange();
    }
  }

  public assignInputs(config, isRewrite?: boolean) {
    const result = {};
    isRewrite ? Object.assign(result, this.inputs, config) : Object.assign(result, config, this.inputs);
    Object.assign(this.inputs, result);
    this.onChange();
  }

  public assignInput(key, config) {
    if (!this.inputs[key]) {
      this.inputs[key] = {};
    }

    if (this.inputs[key].hasOwnProperty('mapLabelCSSStyle')) {
      this.inputs[key].mapLabelCSSStyle = '';
    }

    Object.assign(this.inputs[key], config);

    this.onChange();
  }

  public getInputs() {return this.inputs;}

  public getCopyOfInputs(){
    return JSON.parse(JSON.stringify(this.inputs, (k, v)=>{
      if (k && (k.toString().indexOf('w3w') != -1 || k.toString().indexOf('3words') != -1)) {
        return undefined;
      }
      if (v && (v.toString().indexOf('calculation') != -1 || v.toString().indexOf('w3w') != -1 || v.toString().indexOf('3words') != -1)) {
        return undefined;
      }
      return v;
    }))
  }

  public getInputByName(name) {
    return (this.inputs) ? this.inputs[name] || null : null;
  }

  public getInputProp(name, prop) {
    return (this.inputs.hasOwnProperty(name) && this.inputs[name].hasOwnProperty(prop)) ? this.inputs[name][prop] : null;
  }

  public removeInput(key) {
    delete this.inputs[key];
    this.onChange();
  }
  public removeInputProp(key, prop) {
    delete this.inputs[key][prop];
    this.onChange();
  }

  public getTool() { return appInjector.get(ToolsService).getToolById(this.getToolId()); }

  public getToolParam(param) {
    return (appInjector.get(ToolsService).getToolById(this.getToolId()).params)
      ? appInjector.get(ToolsService).getToolById(this.getToolId()).params[param]
      : null;
  }

  public assign(config, withoutOldConfig?) {
    let isToolChanged = false;
    // console.error('assign 321123', this.toolId, config.toolId);
    // if (this.toolId != null && this.toolId != config.toolId){
    //   isToolChanged = true;
    // }

    let savedInputs = {};
    for (const name in this.inputs) {
      if (name.indexOf('point_height') === 0) {
        savedInputs[name] = this.inputs[name];
      }
    }

    if (config instanceof ItemConfig) {
      this.id = config.id || null;
      this.toolId = config.toolId;
      this.title = config.title;
      this.originalTitle = config.originalTitle;
      if (Array.isArray(config.inputs)) {
        this.inputs = {};
      } else {
        this.inputs = config.inputs || {};
      }
      this.group = config.group;
      this.groupId = config.groupId;
      this.copyOf = config.copyOf;
      this._copyDirection = config.copyDirection;
      this._copyGapInMeters = config.copyGapInMeters;
      this.hasTag = config.hasTag;
      this.showTag = config.showTag;
      this.bundledItems = config.bundledItems;
      this.teamId = config.teamId;
      this.team = config.team;
      this.creator = config.creator;
      this.creatorEmail = config.creatorEmail;
      this.createdAt = config.createdAt;
      this.concreteLayerId = config.concreteLayerId;;
      this.pluginConfigs = config.pluginConfigs;

      // if (this.inputs.hasOwnProperty('__figure_zoom')){
      //   config.getObjectConfig().fixed_scale = this.getInputProp('__figure_zoom', 'value');
      // }

      this.setObjectConfig(config.getObjectConfig(), withoutOldConfig);
    } else {
      if (config.hasOwnProperty('id')) { this.id = config.id; }
      if (config.hasOwnProperty('toolId')) { this.toolId = config.toolId; }
      if (config.hasOwnProperty('title')) { this.title = config.title; }
      if (config.hasOwnProperty('originalTitle')) { this.originalTitle = config.originalTitle; }
      if (config.hasOwnProperty('inputs')) {
        if (Array.isArray(config.inputs)) {
          this.inputs = {};
        } else {
          this.inputs = config.inputs || {};
        }
      }
      if (config.hasOwnProperty('group')) { this.group = config.group; }
      if (config.hasOwnProperty('groupId')) { this.groupId = config.groupId; }
      if (config.hasOwnProperty('copyOf')) { this.copyOf = config.copyOf; }
      if (config.hasOwnProperty('copyDirection')) { this._copyDirection = config.copyDirection; }
      if (config.hasOwnProperty('copyGapInMeters')) { this._copyGapInMeters = config.copyGapInMeters; }
      if (config.hasOwnProperty('hasTag')) { this.hasTag = config.hasTag; }
      if (config.hasOwnProperty('showTag')) { this.showTag = config.showTag; }
      if (config.hasOwnProperty('bundledItems')) { this.bundledItems = config.bundledItems; }
      if (config.hasOwnProperty('teamId')) { this.teamId = config.teamId; }
      if (config.hasOwnProperty('team')) { this.team = config.team; }
      if (config.hasOwnProperty('creator')) { this.creator = config.creator; }
      if (config.hasOwnProperty('creatorEmail')) { this.creatorEmail = config.creatorEmail; }
      if (config.hasOwnProperty('createdAt')) { this.createdAt = config.createdAt; }
      if (config.hasOwnProperty('concreteLayerId')) { this.concreteLayerId = config.concreteLayerId; }
      if (config.hasOwnProperty('pluginConfigs')) { this.pluginConfigs = config.pluginConfigs; }

      // if (this.inputs.hasOwnProperty('__figure_zoom') && this.inputs['__figure_zoom'].hasOwnProperty('value')){
      //   config.objects[0].fixed_scale = this.inputs['__figure_zoom']['value'];
      // }

      if (config.hasOwnProperty('objects')) {
        if (this.getTool() && !this.getTool().dynamic_image_code && !this.getTool().url_for_dynamic_icon) {
          config.objects[0].map_icon = this.getTool().map_icon;
        }
        this.setObjectConfig(config.objects[0], withoutOldConfig);
      }
    }


    if (typeof this.inputs == 'string') {
      this.inputs = {};
    }
      for (const i in this.inputs) {
        if (this.inputs.hasOwnProperty(i)) {
          this.inputs[i].getValue = function () {
            // todo: rewrite this part for 2.1
            // if (this.hasOwnProperty('calculation')) {
            //   return $scope.calculateObjectParam(item, this.calculation, p, true);
            // }
            let v = this.value;
            if (this.hasOwnProperty('suffix')) {
              v += this.suffix;
            }
            return v;
          };
          this.inputs[i].getNumericValue = function () {
            // todo: rewrite this part for 2.1
            // if (this.hasOwnProperty('calculation')) {
            //   return parseFloat($scope.calculateObjectParam(item, this.calculation, p, true));
            // }
            return parseFloat(this.value);
          };
      }
    }

    for (const name in savedInputs) {
      if (!this.inputs.hasOwnProperty(name)) {
        this.inputs[name] = savedInputs[name];
      }
    }

    this.mapInputsToTool();

    if (!withoutOldConfig) {
      this.initializeOldConfig();
    }
    this._serverUpdate.next(this);
  }

  public forceChange(){
    this.onChange();
  }

  //todo: is it right way?
  public assignWithSave(config){

    this.assign(config, true);
    this.onChange();
  }

  public setRotation(degrees) {
    this.getObjectConfig().setRotation(degrees);
  }

  public asJSON() {
    return JSON.stringify(this, (k, v) => {
      if (k === 'objects') {
        return [this.getObjectConfig().asSimpleObject()];
      }
      if ([
        '_oldConfigHash', 'oldConfig', 'subject',
        '_subject', 'serverUpdate', '_serverUpdate',
        'mapInputsToObjectConfig', '_convertedInputs'
      ].includes(k)) {
        return undefined;
      }
      return v;
    });
  }

  public asSimpleObject(): any {
    let currentJson = this.asJSON();
    currentJson = currentJson.replace(/_copy/g, 'copy');
    return JSON.parse(currentJson);
  }

  protected initializeOldConfig() {
    this._oldConfigHash = this.asJSON();
  }

  public hasChange() {
    if (this.id) {
      if (this._oldConfigHash !== null) {
        const newConfigHash = this.asJSON();
        if (this._oldConfigHash !== newConfigHash) {
          return true;
        }
      }
    }
    return false;
  }

  protected onChange(): void {
    if (this.id) {
      if (this._oldConfigHash !== null) {
        const newConfigHash = this.asJSON();
        if (this._oldConfigHash !== newConfigHash) {
          if (location.search.indexOf('debug_socketio=1') >= 0) {
            console.log('=> SOCKETIO [configs]:', this._oldConfigHash, newConfigHash);
          }
          this.oldConfig = this.asSimpleObject();

          this._oldConfigHash = newConfigHash;
          this._subject.next(this);
        }
        else{
        }
      }
      else{ }
    }
    else{

    }
  }

  private mapInputsToTool(): void {
    const tool = this.getTool();
    const mappedInputs = ['colorSetting', 'opacitySetting'];
    const inputsKeys = Object.keys(this.inputs);

    mappedInputs.forEach((inputKey) => {
      if (inputsKeys.includes(inputKey)) {
        tool.setAdditionalObject(this.id, 'mappedInputs', {[inputKey]: this.inputs[inputKey]});
      }
    });
  }
}


